import React, { Component } from 'react';
import '../less/index.less'
import jianghong from '../images/jianghong.png'
import bolin from '../images/bolin.jpg'
import haikang from '../images/haikang.jpg'

class CorporationCase extends Component {
    render() {
        return (
            <div className="corporationCase">
                {/* <div className="About1"> 
                    <div className="AboutLeft">
                        <p className="AboutTitle">海康威视</p>
                        <p>海康威视全球领先的视频监控服务商遍布全球70多个国家的45，000名员工为世界各地的租户及投资者提供服务；年营业额高达50亿美元是一家非常专业和国际化的公司，双方合作，正是基于海康威视对灵捷专业的认可。</p>
                    </div>
                    <div className="AboutRight">
                        <img src={haikang}/>
                    </div>
                </div> */}
                <div className="About1"> 
                    <div className="AboutLeft">
                        <p className="AboutTitle">柏林印象</p>
                        <p>作为大楼物业，需服务好楼内客户，但对于各个快递公司的快递员也需要进行管控，大楼不愿开放快递员任意进入，所以无论是基于成本开销、大楼形象还是客户体验，这一问题大楼收发室就可以解决掉。</p>
                    </div>
                    <div className="AboutRight">
                        <img src={bolin}/>
                    </div>
                </div>
                <div className="About1"> 
                    <div className="AboutLeft">
                        <p className="AboutTitle">江虹国际创业园</p>
                        <p>三花江虹国际文化创意园位于杭州滨江区中心位置，由绿城物管运营。园区外与阿里巴巴、网易等名企为邻。

园区总建筑面积8万多㎡，可根据客户需求选择分割，公共部门标准精装，可满足中小型企业的需求，得房率高，装修风格自主。</p>
                    </div>
                    <div className="AboutRight">
                        <img src={jianghong}/>
                    </div>
                </div>
            </div>
        )
    }
}

export default CorporationCase;